import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-exemplo-decisao-certa',
  templateUrl: './exemplo-decisao-certa.component.html',
  styleUrls: ['./exemplo-decisao-certa.component.scss']
})
export class ExemploDecisaoCertaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  menuItems = [
    { link: 'topico0', text: 'Resumo ', active: true },
    { link: 'topico1', text: 'Dados Estaduais ', active: false },
    { link: 'topico2', text: 'Dados Nacionais ', active: false },
    { link: 'topico3', text: 'Histórico de Roubo e Furto ', active: false },
    { link: 'topico4', text: 'Indício de Sinistro ', active: false },
    { link: 'topico5', text: 'Indício de Sinistro 2 ', active: false },
    { link: 'topico6', text: 'Parecer Técnico ', active: false },
    { link: 'topico7', text: 'Decodificador de Chassi ', active: false },
    { link: 'topico8', text: 'Remarketing ', active: false },
    { link: 'topico9', text: 'Localizador de Chassi e Motor (Cortesia) ', active: false },
    { link: 'topico10', text: 'Base de Leilão 1 ', active: false },
    { link: 'topico11', text: 'Base de Leilão 2 ', active: false },
    { link: 'topico12', text: 'Base de Leilão 3 ', active: false },
    { link: 'topico13', text: 'Preço Mercado Financeiro (Cortesia) ', active: false },
    { link: 'topico14', text: 'Desvalorização Média (Cortesia) ', active: false },
    { link: 'topico15', text: 'Histórico de Proprietário (Cortesia) ', active: false },
  ];


  topicos = [
    { id: 0, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t21.jpg'], botoes: null },
    { id: 1, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t22.jpg'], botoes: null },
    { id: 2, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t23.jpg'], botoes: null },
    { id: 3, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t23.png'], botoes: null },
    { id: 4, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t24-1.png'], botoes: null },
    { id: 5, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t25-1.png'], botoes: null },
    { id: 6, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t116.png'], botoes: null },
    { id: 7, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t27.jpg'], botoes: null },
    { id: 8, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t28.png'], botoes: null },
    { id: 9, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t29.png'], botoes: null },
    { id: 10, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t210.jpg'], botoes: null },
    { id: 11, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t211.png'], botoes: null },
    { id: 12, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t212.png'], botoes: null },
    { id: 13, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/pmf-1.png'], botoes: null },
    { id: 14, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t214.png'], botoes: null },
    { id: 15, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/hp-1.png'], botoes: null },
  ];

  imgAtiva = {
    1: 1,
    2: 1,
    3: 1,
    4: 1,
    5: 1,
    6: 1,
    7: 1,
    8: 1,
    9: 1,
    10: 1,
    11: 1,
    12: 1,
    13: 1,
    14: 1,
    15: 1
  };

  mostraImagem(topicoId: number, imgId: number) {
    this.imgAtiva[topicoId] = imgId;

    const topico = this.topicos.find(t => t.id === topicoId);
    if (topico && topico.botoes) {
      topico.botoes.forEach(botao => botao.ativo = (botao.id === imgId));
    }
  }

  scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.updateActiveMenuItem(id);
    }
  }

  updateActiveMenuItem(activeLink: string) {
    this.menuItems.forEach(item => item.active = (item.link === activeLink));
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {

    const distanciaDoTopo = 150;

    this.menuItems.forEach((item) => {
      const element = document.getElementById(item.link);
      if (element) {
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;

        if (elementTop <= window.scrollY + distanciaDoTopo) {
          this.updateActiveMenuItem(item.link);
        }
      }
    });
  }

}
